// функция, которая по заданному селектору
// найдет соответствующие ему элементы, которые
// при этом попадают в видимую область окна
//e.x. let viewsComments = inWindow("div.new-comment");

function inWindow(selector){
  let scrollTop = document.documentElement.scrollTop;
  let windowHeight = document.documentElement.clientHeight;
  let elements = document.querySelectorAll(selector);
  let result = [];
  elements.forEach((element) => {
    if(scrollTop <= element.offsetTop && (element.offsetHeight + element.offsetTop) < (scrollTop + windowHeight)){
      result.push(element);
    }
  });
  return result;
};

export default inWindow;